import { useEffect } from "react";
import { useMap } from "react-leaflet";

export interface MapPopupControllerProps {
  selection: unknown;
}

/**
 * Closes the open Leaflet popup when the feature selection is cleared.
 */
export const MapPopupController = ({ selection }: MapPopupControllerProps) => {
  const map = useMap();

  useEffect(() => {
    if (selection === null || selection === undefined) map.closePopup();
  }, [map, selection]);

  return null;
};

export default MapPopupController;
